import { render, staticRenderFns } from "./CoursewareDownloadBlock.vue?vue&type=template&id=26fa4af0&scoped=true&"
import script from "./CoursewareDownloadBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareDownloadBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareDownloadBlock.vue?vue&type=style&index=0&id=26fa4af0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa4af0",
  null
  
)

export default component.exports